export default __webpack_public_path__ + "static/media/4622.6e790756.png";